import { WcsLocalizedMessage } from '@/scripts/libs/wcs/types/wcs-config'

export class WcsLocales {
  static AR_AR = 'ar-AR'
  static CY_EN = 'cy-EN'
  static DE_AT = 'de-AT'
  static DE_CH = 'de-CH'
  static DE_DE = 'de-DE'
  static DE_LU = 'de-LU'
  static EL_GR = 'el-GR'
  static EN_AU = 'en-AU'
  static EN_CA = 'en-CA'
  static EN_CH = 'en-CH'
  static EN_CN = 'en-CN'
  static EN_CY = 'en-CY'
  static EN_CZ = 'en-CZ'
  static EN_DK = 'en-DK'
  static EN_DZ = 'en-DZ'
  static EN_EE = 'en-EE'
  static EN_EU = 'en-EU'
  static EN_FI = 'en-FI'
  static EN_GB = 'en-GB'
  static EN_GR = 'en-GR'
  static EN_UK = 'en-UK'
  static EN_HK = 'en-HK'
  static EN_HU = 'en-HU'
  static EN_ID = 'en-ID'
  static EN_IE = 'en-IE'
  static EN_IL = 'en-IL'
  static EN_LT = 'en-LT'
  static EN_LU = 'en-LU'
  static EN_LV = 'en-LV'
  static EN_ME = 'en-ME'
  static EN_MT = 'en-MT'
  static EN_MY = 'en-MY'
  static EN_NL = 'en-NL'
  static EN_NO = 'en-NO'
  static EN_PK = 'en-PK'
  static EN_PL = 'en-PL'
  static EN_PT = 'en-PT'
  static EN_SE = 'en-SE'
  static EN_SG = 'en-SG'
  static EN_SI = 'en-SI'
  static EN_SK = 'en-SK'
  static EN_TH = 'en-TH'
  static EN_US = 'en-US'
  static EN_VN = 'en-VN'
  static EN_XX = 'en-XX'
  static ES_AR = 'es-AR'
  static ES_ES = 'es-ES'
  static ES_LA = 'es-LA'
  static ES_MX = 'es-MX'
  static ET_EE = 'et-EE'
  static FI_FI = 'fi-FI'
  static FR_BE = 'fr-BE'
  static FR_CA = 'fr-CA'
  static FR_CH = 'fr-CH'
  static FR_FR = 'fr-FR'
  static HI_IN = 'hi-IN'
  static HR_HR = 'hr-HR'
  static IT_CH = 'it-CH'
  static IT_IT = 'it-IT'
  static JA_JP = 'ja-JP'
  static KO_KR = 'ko-KR'
  static LT_LT = 'lt-LT'
  static LV_LV = 'lv-LV'
  static NL_BE = 'nl-BE'
  static NL_NL = 'nl-NL'
  static PL_PL = 'pl-PL'
  static PT_BR = 'pt-BR'
  static PT_PT = 'pt-PT'
  static RO_RO = 'ro-RO'
  static RU_RU = 'ru-RU'
  static SL_SI = 'sl-SI'
  static SV_SE = 'sv-SE'
  static TR_TR = 'tr-TR'
  static EN_TR = 'en-TR'
  static UK_UA = 'uk-UA'
  static ZH_CN = 'zh-CN'
  static ZH_HK = 'zh-HK'
  static ZH_TW = 'zh-TW'

  static COUNTRIES_WITH_STELLA = [
    WcsLocales.DE_AT,
    WcsLocales.DE_DE,
    WcsLocales.EN_AU,
    WcsLocales.EN_CA,
    WcsLocales.EN_GB,
    WcsLocales.EN_PT,
    WcsLocales.EN_US,
    WcsLocales.ES_ES,
    WcsLocales.FR_BE,
    WcsLocales.FR_CA,
    WcsLocales.FR_FR,
    WcsLocales.IT_IT,
    WcsLocales.NL_BE,
  ]

  static mapCurrentStore = (locale: string) => {
    switch (locale) {
      case WcsLocales.IT_IT:
        return 'italy'
      case WcsLocales.EN_US:
        return 'usa'
      case WcsLocales.DE_DE:
        return 'germany'
      case WcsLocales.EN_GB:
        return 'uk'
      case WcsLocales.DE_AT:
        return 'austria'
      case WcsLocales.DE_CH:
        return 'switzerland/de'
      case WcsLocales.FR_CH:
        return 'switzerland/fr'
      case WcsLocales.IT_CH:
        return 'switzerland/it'
      case WcsLocales.EN_CH:
        return 'switzerland/en'
      case WcsLocales.FR_BE:
        return 'belgium/fr'
      case WcsLocales.NL_BE:
        return 'belgium/nl'
      case WcsLocales.FR_FR:
        return 'france'
      case WcsLocales.FR_CA:
        return 'canada/fr'
      case WcsLocales.EN_CA:
        return 'canada/en'
      case WcsLocales.EN_AU:
        return 'australia'
      case WcsLocales.JA_JP:
        return 'japan'
      case WcsLocales.ES_MX:
        return 'mexico'
      case WcsLocales.PT_BR:
        return 'brazil'
      case WcsLocales.ES_ES:
        return 'spain'
      case WcsLocales.EN_PL:
        return 'poland'
      case WcsLocales.EN_SE:
        return 'sweden'
      case WcsLocales.ES_AR:
        return 'latam'
      case WcsLocales.EN_TH:
        return 'asean'
      case WcsLocales.EN_DK:
        return 'denmark'
      case WcsLocales.EN_HK:
        return 'hongkong/en'
      case WcsLocales.ZH_HK:
        return 'hongkong/zh'
      case WcsLocales.HI_IN:
        return 'india'
      case WcsLocales.EN_IE:
        return 'ireland'
      case WcsLocales.EN_IL:
        return 'row'
      case WcsLocales.KO_KR:
        return 'korea'
      case WcsLocales.EN_DZ:
        return 'mea'
      case WcsLocales.NL_NL:
        return 'netherlands'
      case WcsLocales.EN_NO:
        return 'norway'
      case WcsLocales.PT_PT:
        return 'portugal'
      case WcsLocales.EN_TR:
        return 'turkey'
      case WcsLocales.EN_FI:
      case WcsLocales.EN_EU:
      case WcsLocales.EN_GR:
      case WcsLocales.CY_EN:
      case WcsLocales.ET_EE:
      case WcsLocales.EL_GR:
      case WcsLocales.LV_LV:
      case WcsLocales.LT_LT:
      case WcsLocales.DE_LU:
      case WcsLocales.EN_MT:
      case WcsLocales.EN_SK:
      case WcsLocales.SL_SI:
        return 'eu'
      default:
        return 'usa'
    }
  }

  static mapPrivacyPolicyLink = (locale: keyof WcsLocales) => {
    switch (locale) {
      case WcsLocales.IT_IT:
        return 'politica-privacy'
      case WcsLocales.DE_DE:
      case WcsLocales.DE_AT:
        return 'datenschutz'
      case WcsLocales.FR_BE:
        return 'confidentialite-et-securite'
      case WcsLocales.PT_BR:
      case WcsLocales.PT_PT:
        return 'politica-privacidade'
      default:
        return 'privacy-policy'
    }
  }

  static mapTermsOfUseLink = (locale: string) => {
    switch (locale) {
      case WcsLocales.IT_IT:
        return 'termini-utilizzo'
      case WcsLocales.DE_DE:
      case WcsLocales.DE_AT:
        return 'benutzungsbedingungen'
      case WcsLocales.FR_BE:
      case WcsLocales.FR_FR:
      case WcsLocales.FR_CA:
        return 'conditions-generales'
      case WcsLocales.PT_BR:
      case WcsLocales.PT_PT:
        return 'politica-devolucoes'
      case WcsLocales.ES_MX:
        return 'terminos-de-uso'
      default:
        return 'terms-of-use'
    }
  }

  static getPrivacyPolicyLink = (locale: keyof WcsLocales) => {
    const store = WcsLocales.mapCurrentStore(locale)
    const privacyPolicyLink = this.mapPrivacyPolicyLink(locale)
    return `${window.location.origin}/${store}/c/${privacyPolicyLink}`
  }

  static getTermsAndConditionsLink = (locale: string) => {
    const store = WcsLocales.mapCurrentStore(locale)
    const termsOfUseLink = this.mapTermsOfUseLink(locale)
    return `${window.location.origin}/${store}/c/${termsOfUseLink}`
  }

  // TODO: Merge this function
  static getCountryCode = (locale: string) => {
    const splitLocale = locale?.split('_')
    return splitLocale && splitLocale[1] ? splitLocale[1] : ''
  }

  // TODO: Merge this function
  static mapCountryCode = (locale: string) => {
    const splitLocale = locale?.split('-')
    return splitLocale && splitLocale[1] ? splitLocale[1] : 'US'
  }

  static mapLanguageCode = (locale: string) => {
    const splitLocale = locale?.split('-')
    return splitLocale && splitLocale[0] ? splitLocale[0] : ''
  }

  static getSanitizedLocale = (locale: string) => {
    if (locale === WcsLocales.EN_NL) {
      return WcsLocales.NL_NL
    }
    if (locale === WcsLocales.EN_SE) {
      return WcsLocales.SV_SE
    }
    if (locale === WcsLocales.EN_PL) {
      return WcsLocales.PL_PL
    }
    return locale
  }

  static getLocalizedMessage = (promoMessage: WcsLocalizedMessage, locale: string) => {
    switch (locale) {
      case WcsLocales.EN_CA:
        return promoMessage.en_CA
      case WcsLocales.FR_CA:
        return promoMessage.fr_CA
      case WcsLocales.DE_CH:
        return promoMessage.de_CH
      case WcsLocales.EN_CH:
        return promoMessage.en_CH
      case WcsLocales.FR_CH:
        return promoMessage.fr_CH
      case WcsLocales.IT_CH:
        return promoMessage.it_CH
      case WcsLocales.FR_BE:
        return promoMessage.fr_BE
      case WcsLocales.NL_BE:
        return promoMessage.nl_BE
      case WcsLocales.EN_HK:
        return promoMessage.en_HK
      case WcsLocales.ZH_HK:
        return promoMessage.zh_HK
      default:
        return promoMessage.default
    }
  }
}
